<template>
  <nav class="nav--bottom">
    <router-link
      to="/dashboard"
      class="nav___link"
      v-if="$route.name == 'Dashboard' || $route.name == 'Create'"
    >
      <i class="material-icons-outlined nav___icon">dashboard</i>
      <!-- <span class="nav___text">Home</span> -->
    </router-link>
    <router-link
      to="/"
      class="nav___link"
      v-if="$route.name != 'Dashboard' && $route.name !== 'Create'"
    >
      <i class="material-icons-outlined nav___icon">home</i>
      <!-- <span class="nav___text">Home</span> -->
    </router-link>
    <router-link
      to="/projects"
      class="nav___link"
      v-if="$route.name != 'Dashboard' && $route.name !== 'Create'"
    >
      <i class="material-icons-outlined nav___icon">apps</i>
      <!-- <span class="nav___text">Home</span> -->
    </router-link>

    <router-link
      to="/technologies"
      class="nav___link"
      v-if="$route.name != 'Dashboard' && $route.name !== 'Create'"
    >
      <i class="material-icons-outlined nav___icon">code</i>
      <!-- <span class="nav___text">Home</span> -->
    </router-link>
    <router-link
      to="/socials"
      class="nav___link"
      v-if="$route.name != 'Dashboard' && $route.name !== 'Create'"
    >
      <i class="material-icons-outlined nav___icon">chat</i>
      <!-- <span class="nav___text">Home</span> -->
    </router-link>
    <router-link
      to="/create"
      class="nav___link"
      v-if="$route.name == 'Dashboard' || $route.name == 'Create'"
    >
      <i class="material-icons-outlined nav___icon">add</i>
      <!-- <span class="nav___text">Home</span> -->
    </router-link>
    <router-link
      to=""
      @click="logout"
      class="nav___link"
      v-if="$route.name == 'Dashboard' || $route.name == 'Create'"
    >
      <i class="material-icons-outlined nav___icon">logout</i>
      <!-- <span class="nav___text">Home</span> -->
    </router-link>
  </nav>
</template>

<script>
import { useStore } from "vuex";
export default {
  props: [],
  setup() {
    const store = useStore();
    const logout = () => {
      store.dispatch("LogOut");
    };
    return {
      logout,
    };
  },
};
</script>

<style scoped>
@media only screen and (min-width: 576px) {
  .nav--bottom {
    display: none;
  }
}
@media only screen and (max-width: 576px) {
  .nav--bottom {
    position: fixed;
    height: 54px;
    bottom: 0;
    width: 100%;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.3);
    border-top: 1px rgb(201, 197, 197) solid;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
  }

  .nav___link {
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    width: 25%;
    overflow: hidden;
    white-space: nowrap;
    color: #555353;
    text-decoration: none !important;
    -webkit-tap-highlight-color: transparent;
    transition: background-color 0.5s ease-in-out;
  }

  .nav___link:hover {
    color: #765cd1;
  }

  .nav___icon {
    font-size: 22px;
    justify-content: center !important;
    text-align: center;
    display: flex;
    flex-direction: column;
  }

  .router-link-exact-active {
    color: #765cd1;
  }
}
</style>
